export const blockIconsBusinessandpaymentsQrCodeScannerNew = (
	<span className='material-symbols-outlined'>qr_code_scanner</span>
);
